/**
 * SeatNameEditor.jsx
 * Dialog for naming all seats in a specific row.
 */
import React, { useState, useEffect, useRef } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Box, Typography,
} from '@mui/material';

const navy = '#1e3a5f';

const SeatNameEditor = ({ open, onClose, row, onSave }) => {
  const [seats, setSeats] = useState([]);
  const inputRefs = useRef([]);

  useEffect(() => {
    if (row?.seats) {
      setSeats(row.seats.map(s => ({ ...s })));
    }
  }, [row]);

  const handleChange = (index, value) => {
    setSeats(prev => prev.map((s, i) => i === index ? { ...s, occupant: value } : s));
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Tab' || e.key === 'Enter') {
      e.preventDefault();
      const next = index + 1;
      if (next < inputRefs.current.length) {
        inputRefs.current[next]?.focus();
      }
    }
  };

  const handleSave = () => {
    onSave(seats);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { direction: 'rtl' } }}
    >
      <DialogTitle sx={{ bgcolor: navy, color: '#fff', fontSize: 16, py: 1.5 }}>
        שיוך שמות למושבים
      </DialogTitle>
      <DialogContent sx={{ pt: 2, pb: 1 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          הזינו שם לכל מושב. השאירו ריק למושב פנוי.
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {seats.map((seat, index) => (
            <Box key={seat.id} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="body2" sx={{ minWidth: 50, color: '#888', fontSize: 13 }}>
                מושב {index + 1}
              </Typography>
              <TextField
                inputRef={el => inputRefs.current[index] = el}
                size="small"
                fullWidth
                placeholder="פנוי"
                value={seat.occupant || ''}
                onChange={(e) => handleChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                sx={{ '& .MuiInputBase-input': { fontSize: 14 } }}
              />
            </Box>
          ))}
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} sx={{ color: '#666' }}>ביטול</Button>
        <Button
          variant="contained"
          onClick={handleSave}
          sx={{ bgcolor: navy, '&:hover': { bgcolor: '#152844' } }}
        >
          שמור
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SeatNameEditor;
